













import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIWizardObjectDecoratable, IWizardInputDecoratable } from "../../../../../../domain/format";
import { FatalIndicator, QuotedBadge } from "./common";
import { TextInputtableContentMixin } from "./mixins";

@Component({
  components: {
    FatalIndicator,
    QuotedBadge,
  }
})
export default class WizardContentTextInput extends Mixins(TextInputtableContentMixin) {
  get prefix(): string {
    return this.readDecoration(s => s.prefix);
  }

  get postfix(): string {
    return this.readDecoration(s => s.postfix);
  }

  private readDecoration(read: (s: IWizardInputDecoratable) => string): string {
    return (instanceOfIWizardObjectDecoratable(this.content) && !!read(this.content.decoration))
      ? read(this.content.decoration)
      : "";
  }
}
